import React from "react";
import "./Experience.css";

const Experience = () => {
  return (
    <div className="experience">
      <div className="achievement">
        <div className="circle">6+</div>
        <span>years In</span>
        <span>Mdeia & Content Industry</span>
      </div>
      <div className="achievement">
        <div className="circle">3+</div>
        <span>years In</span>
        <span>TKIF</span>
      </div>
      <div className="achievement">
        <div className="circle">5+</div>
        <span>years In</span>
        <span>Translation & Marketing</span>
      </div>
    </div>
  );
};

export default Experience;
